export const data = [
  {
    de: "Brettspiele",
    en: "Board games",
  },
  `Brändi Dog __🌭__`,
  `Flat White __☕__`,
  {
    de: "Digitale Kunst",
    en: "Digital Art",
  },
  {
    de: `Spieleentwicklung __🕹️__`,
    en: `Game Development __🕹️__`,
  },
  "Soul Music",
  "Fantasy Fiction",
  "Science Fiction",
  {
    de: "Weltraum",
    en: "Space",
  },
  "Soul Music",
  {
    de: "Computergrafik",
    en: "Computer Graphics",
  },
  {
    de: "Generative Kunst",
    en: "Generative Art",
  },
  {
    de: "Kreative Programmierung",
    en: "Creative Coding",
  },
  "3D Rendering",
  "3D Sculpting",
  "Simulation",
  {
    de: `Mein Name ist Guybrush Threepwood __🙊__`,
    en: `My name is Guybrush Threepwood __🙊__`,
  },
  `Badminton __🏸__`,
  {
    de: "Freunde & Familie",
    en: "Friends & Family",
  },
  {
    de: "Freunde sind Familie",
    en: "Friends are Family",
  },
  {
    de: "Berge",
    en: "Mountains",
  },
  "Gemischtes Hack",
  {
    de: `Sonnenschein __🌞__`,
    en: `Sunshine __🌞__`,
  },
  {
    de: `Kochen __🍳__`,
    en: `Cooking __🍳__`,
  },
  {
    de: "Portraitmalerei",
    en: "Portrait painting",
  },
  "Marvel Comics",
  "Kim Jung Gi",
  "Karl Kopinski",
  "Simon Stålenhag",
  "John Singer Sargent",
  "Breaking Bad",
  {
    de: "Technologie",
    en: "Technology",
  },
  {
    de: "Programmieren",
    en: "Programming",
  },
  {
    de: `Katzen __😺__`,
    en: `Cats __😺__`,
  },
  {
    de: "Hunde",
    en: "Dogs",
  },
  "Cornish Pasties",
  "Carajillo",
  "Tiramisù",
  "Whisky sour",
  `Cinema __🍿__`,
  `NES __👾__`,
  "Aliens",
  "Hardware",
  `Monkey Island __🦜__`,
  "Indiana Jones",
  "Star Wars",
  "Konami Code",
  "Binge watching",
  "The Wire",
  "Drizzt Do'Urden",
  "The Matrix",
  "What is real?",
  "Flutes",
  {
    de: "Käse",
    en: "Cheese",
  },
  `Arancini __🍘__`,
  {
    de: "Pistazien",
    en: "Pistachio",
  },
  {
    de: `Arbeite für Pizza __🍕__`,
    en: `Will work for Pizza __🍕__`,
  },
  `Rick and Morty __🥼__`,
  "Futurama",
  `Wall-E __🤖__`,
  {
    de: "Das fünfte Element",
    en: "The Fifth Element",
  },
  "The Fifth Element",
  "Syndicate",
  "El Tony",
  `Procreate __🎨__`,
  "iPad Pro",
];
